import BaseStore, { LOADED, LOADING } from 'stores/BaseStore';
import config from 'config';
import HttpClient from 'utils/httpclient';
import settingStore from 'modules/cms/stores/setting';

export default new class FormStore extends BaseStore {
  constructor() {
    super('forms', 'form', { site_model: true });
  }

  datasourceTemplates = defineDatasource(settingStore.getTemplates(
    '/partials/forms/components/custom_fields/datasource',
    [{ value: '', label: 'Default' }]
  ))

  async references(form_id) {
    const params = { site_id: this.getCurrentSiteID() }
    this.entity.readyState = LOADING;
    const { data } = await HttpClient.get(`${config.api}/form/${form_id}/references`, { params })
    this.entity.readyState = LOADED;
    return data;
  }

  getFields(all = true) {
    return HttpClient.get(`${config.api}/site/${this.getCurrentSiteID()}/${all ? 'getFields' : 'customFields'}`)
      .then(response => {
        return response.data;
      });
  }
}

function defineDatasource(templateLoader) {
  const stateLoader = type => {
    let options = null
    return async () => {
      if (!options) {
        options = await templateLoader(type)
        setTimeout(() => {
          options = null
        }, 3000)
      }
      return options
    }
  }
  return {
    loading: stateLoader('feedback-loading'),
    empty: stateLoader('feedback-empty'),
    search_filter: stateLoader('search-filter'),
  }
}